<template>
  <div>
    <Row type="flex" align="middle">
      <table class="TB_COLLAPSE" width="100%">
        <thead>
          <th colspan="12">基本讯息</th>
        </thead>
        <tbody>
          <tr v-for="(it,index) in usrtmsg" :key="index+'user'">
            <th>名称</th>
            <td class="fontweight">{{it.username}}</td>
            <th>帐号</th>
            <td class="fontweight">{{it.memname}}</td>
          </tr>
        </tbody>
      </table>
      <table class="lida-leading-table" width="100%">
        <thead>
          <th colspan="12">{{ gameName }}</th>
        </thead>
        <tbody>
          <tr v-for="(it, indext) in chunkitme.length" :key="indext">
            <td>
              <table class="lida-table-content">
                <tr v-for="(add, index2) in place" :key="'left' + add">
                  <td class="tableinforcolor">{{add}}</td>
                </tr>
              </table>
            </td>
            <td v-for="(res, index2) in chunkitme[indext]" :key="indext + 'chunkitme' + index2">
              <table class="lida-table-content">
                <tr
                  v-for="(add, index3) in keyname(res)"
                  style="width:11.1%;border-left: 1px solid;"
                  :key="indext + 'data' + index3"
                >
                  <td :class="{'tableinforcolor': index3 == 0}">{{add | commaFormat}}</td>
                </tr>
              </table>
            </td>
            <td v-if="chunkitme[indext].length == 9">
              <table class="lida-table-content">
                <tr v-for="(add, index2) in place" :key="'right' + add">
                  <td class="tableinforcolor">{{add}}</td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <lida-table :propscolumns="ipcolumns" :data="loginrecord" :sortStatus="false"></lida-table>
    </Row>
  </div>
</template>
<script>
import { Utile } from "utils";
import { mapGetters } from "vuex";
export default {
  name: 'usermsg',
  data () {
    return {
      usrtmsg: [],
      rsixs: [],
      loginrecord: [],
      place: ["玩法", "佣金A(%)", "佣金B(%)"],
      ipcolumns: {
        indexNumber: {
          title: "序号",
          key: "indexNumber",
          align: "center",
          className: "infor-column",
          width: 60
        },
        logdate: {
          title: "登录日期",
          key: "logdate",
          align: "center"
        },
        ip: {
          title: "IP地址",
          key: "ip",
          align: "center"
        },
        country: {
          title: "国家",
          key: "country",
          align: "center"
        },
        outdate: {
          title: "登出时间",
          key: "outdate",
          align: "center"
        },
        explain: {
          title: "登出原因",
          key: "explain",
          align: "center"
        }
      }
    };
  },
  computed: {
    ...mapGetters(["getmember", "getgameid", "getAllGame"]),
    chunkitme () {
      return Utile.chunk(this.rsixs, 9);
    },
    gameName () {
      if (!this.getAllGame.length) return []
      let name = this.getAllGame.find(it => it.gameid == this.getgameid)
      return name.gamename;
    }
  },
  watch: {
    getgameid () {
      this.ready();
    }
  },
  mounted () {
    this.ready();
  },
  methods: {
    ready () {
      this.ggetusrtmsg();
      this.grsixs();
      this.gloginrecord();
    },
    async ggetusrtmsg () {
      try {
        const res = await this.$axios.personalCenter.ifma(this.getmember.pid, this.getmember.mlevel)
        if ('status' in res && res.status === 0) return
        this.usrtmsg = res;
      } catch (error) {
        console.error(error)
      }
    },
    async grsixs () {
      try {
        const res = await this.$axios.personalCenter.accmsdv(this.getgameid)
        if ('status' in res && res.status === 0) return
        this.rsixs = res.data;
      } catch (error) {
        console.error(error)
      }
    },
    async gloginrecord () {
      try {
        const res = await this.$axios.personalCenter.ifadlog(this.getmember.pid)
        if ('status' in res && res.status === 0) return
        this.loginrecord = res;
      } catch (error) {
        console.error(error)
      }
    },
    // 获取历史记录信息
    keyname (val) {
      return ["pmname", "pcomisa", "pcomisb"].map(res => val[res]);
    }
  }
};
</script>
